import type { MdNodeParser } from '@platejs/markdown';
import { convertChildrenDeserialize, defaultRules } from '@platejs/markdown';
import { KEYS, TextApi, ZERO_WIDTH_SPACE } from 'platejs';

/**
 * A GFM cell contains inline content. Keep it in one paragraph so Slate does not
 * remove links and mentions as invalid siblings of paragraph blocks.
 */
export const tableMarkdownRule: MdNodeParser<'table'> = {
  deserialize: (node, deco, options) => ({
    children: node.children.map((row, rowIndex) => ({
      children: row.children.map(cell => {
        const children = convertChildrenDeserialize(cell.children, deco, options).map(child =>
          TextApi.isText(child) && child.text === ZERO_WIDTH_SPACE ? { ...child, text: '' } : child
        );
        return {
          children: [
            {
              children,
              type: options.editor?.getType(KEYS.p) ?? KEYS.p,
            },
          ],
          type:
            options.editor?.getType(rowIndex === 0 ? KEYS.th : KEYS.td) ??
            (rowIndex === 0 ? KEYS.th : KEYS.td),
        };
      }),
      type: options.editor?.getType(KEYS.tr) ?? KEYS.tr,
    })),
    type: options.editor?.getType(KEYS.table) ?? KEYS.table,
  }),
  serialize: defaultRules.table?.serialize ?? undefined,
};
